'use client';

import { Review, Spacing } from '@kezios/design-system';
import { Flex } from '@mantine/core';

import { SectionLayout } from '../SectionLayout/SectionLayout';

export type ReviewSectionProps = {
  reviews: {
    avatarSrc: string;
    content: string;
    name: string;
    rating: number;
  }[];
};

export const ReviewSection = ({ reviews }: ReviewSectionProps) => {
  return (
    <SectionLayout>
      <Flex gap={Spacing.s16} align="center" justify="center" wrap="wrap">
        {reviews.map((review, index) => (
          <Review
            key={index}
            w={350}
            avatarSrc={review.avatarSrc}
            content={`“${review.content}”`}
            name={review.name}
            rating={review.rating}
          />
        ))}
      </Flex>
    </SectionLayout>
  );
};
